import { registerComponent } from '../app'
import { tns } from 'tiny-slider/src/tiny-slider'
import { ENABLE_LIGHT_MODE, DISABLE_LIGHT_MODE, BROWSER_RESIZE } from '../events'

const Carousel = (scope, el) => {
	const props = {
		autoplay: el.hasAttribute('data-autoplay'),
		autoplayDuration: el.getAttribute('data-autoplay-duration') * 1000,
		lightSlideClass: 'carousel__item--light',
		lightModeClass: 'carousel--light',
		setSlideHeight: el.hasAttribute('data-set-height')
	}

	const els = {
		items: el.querySelector('[data-items]') || el
	}

	const slider = tns({
		container: els.items,
		items: 1,
		slideBy: 'page',
		autoplay: props.autoplay,
		autoplayTimeout: props.autoplayDuration,
		mouseDrag: true,
		autoplayButtonOutput: false,
		swipeAngle: 30,
		preventScrollOnTouch: 'auto'
	})

	function setHeight() {
		if (!props.setSlideHeight) return

		els.items.style.height = els.items.offsetHeight + 'px'
	}

	slider.events.on('indexChanged', info => {
		if (info.slideItems[info.index].classList.contains(props.lightSlideClass)) {
			scope.emit(ENABLE_LIGHT_MODE)
			el.classList.add(props.lightModeClass)
		} else {
			scope.emit(DISABLE_LIGHT_MODE)
			el.classList.remove(props.lightModeClass)
		}
	})

	setHeight()
	scope.on(BROWSER_RESIZE, () => {
		els.items.removeAttribute('style')
		setTimeout(setHeight.bind(this), 500)
	})
}

registerComponent('carousel', Carousel)
